import { Component, OnInit } from '@angular/core';
import { InvestorService } from '../investor.service';
import { Router } from '@angular/router';
//import { TelemetryService } from '@infosys-it/angular-telemetry-sdk';
import { INTERACTEVENTS, IMPRESSIONEVENTS } from 'app/shared/constants';
import { Appconstants } from '../../../shared/app-constants';
import { ViewportScroller } from '@angular/common'
//import { post } from 'selenium-webdriver/http';
import { NgForm } from '@angular/forms';
import { environment } from '../../../../environments/environment.prod';

declare function openprofilesuccessModel();
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  // private telemetryService:TelemetryService
  //constructor(private investorService: InvestorService,private telemetryService:TelemetryService, private router: Router,private vps: ViewportScroller) { }
  constructor(private investorService: InvestorService, private router: Router,private vps: ViewportScroller) { }

  contryData;
  profileData;
  selDemat: string = '';
  primarySharePerc: number = 100;
  pageLoad: boolean = true;
  JSdataToSubmitArray: { shareHolderNumber: number, sharepercent: number, countrycode: string, residency: string, legalstatus: string, document_details: { documentContent: string, documentName: string, documentType: string } }[] = [];
  JSflags = [];
  JSValidationArray: { sharepercent: boolean, country_code: boolean, residency: boolean, document: boolean }[] = [];
  StrPercentError: string[] = [];
  StrPrimaryPercentError: string = '';
  alertMessage: string = '';
  shareholder_details = [];
  other_demat_profile = [];
  all_demat_account = [];
  cycle_details = [];
  disableFlag: boolean = false;
  status: boolean = false;
  indexNum: number;
  disableAttach: boolean = true;
  indexAttach;
  fileByte: string;
  isNR: string;
  disableSubmit: boolean = true;
  primaryDpFolioId: string;
  document: { documentContent: string, documentName: string } = {
    documentContent: "", documentName: ""
  };
  strVerifyResponse: object;
  strErrorMessage: string = "";
  strSuccessMessage: string = "";
  postModel:{country_code: string, share_percent:number}={country_code:"",share_percent:0}
  blnSuccessPopup=false;
  // cycleFlag : boolean = false;
  windowFlag:boolean = false;
  windowStart:Date;
  windowEndDate:Date=new Date();
  windowEnd:Date=new Date();
  today:Date=new Date();
  panNumber:string='';

  ngOnInit() {
    /*
    if(environment.telemetryFlg){
      
      let impressionEventData = {
        type: IMPRESSIONEVENTS.FORM,
        pageid: Appconstants.profilePageId,
        uri: window.location.href
      };
      this.telemetryService.impression(impressionEventData);
    }*/


    this.getProfileData();
    this.getContry();
    console.log(this.profileData);

    console.log("serviceprofile");
  }


  convertFileToByte(file: File, index) {
    this.fileByte = '';
    this.document.documentContent = '';
    this.document.documentName = '';
    console.log("filecheck", file);

    var fileReader: FileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onloadend = (e) => {
      console.log(e);
      this.fileByte = fileReader.result as string;
      this.fileByte = this.fileByte.split(',')[1];
      this.document.documentContent = this.fileByte;
      this.document.documentName = file.name;
      console.log("totalfiles", this.fileByte);
      this.JSdataToSubmitArray[index]['document_details']['documentContent'] = this.fileByte;;
      this.JSdataToSubmitArray[index]['document_details']['documentName'] = file.name;
      this.JSflags[index] = true;
    };
  }

  attachFile(target, targetId) {
    console.log("target", targetId, target['files']);
    console.log("filetype", target['files'][0]['type']);
    if (this.validateType(target['files'][0]['type'], target['files'][0]['name'])) {
      this.convertFileToByte(target['files'][0], targetId);
      this.JSValidationArray[targetId]['document'] = true;
    }
    else {
      console.log("invalid file");
      this.JSdataToSubmitArray[targetId]['document_details']['documentContent'] = '';
      this.JSdataToSubmitArray[targetId]['document_details']['documentName'] = '';
      this.JSValidationArray[targetId]['document'] = false;
      this.JSflags[targetId] = false;
    }
  }

  validateType(type, name) {
    // let accept = ['application/msword', 'application/vnd.ms-excel', 'application/vnd.ms-powerpoint',
    //   'text/plain',' application/pdf', 'image/*'];
    // .xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf
    let re = /(\.pdf)$/
    if (type.match('image/*')) {
      return true;
    }
    else if (re.exec(name)) {
      return true;
    }
    else {
      return false;
    }
  }


  countPerc: number;
  invalidPercFlag: boolean = false;
  invalidCountryFlag: boolean = false;

  checkInvalidSubmit() {
    if (this.JSdataToSubmitArray.length == 0) {
      return false;
    }

    this.JSValidationArray.map((ele, i) => {
      if (ele.sharepercent && (this.JSdataToSubmitArray[i].sharepercent == 0 || this.JSdataToSubmitArray[i].sharepercent == null) && (ele.country_code == undefined && ele.residency == undefined && ele.document == undefined)) {
        this.flagArray[i] = true;
       }

      else if ((ele.country_code === undefined || ele.residency === undefined || ele.document === undefined)) {
        this.flagArray[i] = false;
        console.log("other fields req");
       }
      else if (ele.residency && ele.country_code && ele.sharepercent && ele.document) {
        this.flagdisableSave = false;
        this.flagArray[i] = true;
        console.log("truea", this.flagdisableSave, this.flagArray);
      }
      else {
        this.flagdisableSave = true;
        this.flagArray[i] = false;
        console.log("falsea");
      }
    })

    console.log("finalFlag", this.flagArray);
    if (this.flagArray.length) {
      let sl = true;
      this.flagArray.map(ele => {
        sl = sl && ele;
      })
      if (sl) {
        return false;
      }
      else {
        return true;
      }
    }
    else {
      return true
    }
  }

  fnTakeAction() {
    console.log("submit", this.JSdataToSubmitArray, this.primarySharePerc);

    this.countPerc = -(-this.primarySharePerc);
    this.postModel['share_percent'] = this.primarySharePerc;
    this.postModel['jointshareholderDetails'] = this.JSdataToSubmitArray;
    if (this.JSdataToSubmitArray.length) {
      this.JSdataToSubmitArray.map(ele => {
        this.countPerc += -(-ele.sharepercent);
      })
    }
    if (this.countPerc != 100) {
      this.invalidPercFlag = true;
      this.strErrorMessage = 'Sum of Share percent including primary share must be 100.';
      return;
    }
    if(this.countPerc == 100){
      this.StrPercentError = [];
      this.StrPrimaryPercentError = "";
    }

    if (this.checkInvalidSubmit() == true) {

      this.strErrorMessage = "Please fill all mandatory fields and attach self-declaration document if share-holding percent is entered.";
      return;
    }

   
    this.invalidCountryFlag = false;
    this.invalidPercFlag = false;
    this.strErrorMessage = '';

    console.log("postmodel",this.postModel);
      this.pageLoad= true;
        this.investorService.postProfileData(this.postModel).subscribe(data => {
          this.strVerifyResponse = data as object;
          console.log("output", this.strVerifyResponse);
          if (this.strVerifyResponse['code'] == "1") {
            this.blnSuccessPopup=true;
             openprofilesuccessModel();
             /*if(environment.telemetryFlg){
              let telemetryEventData = {
                type: INTERACTEVENTS.CLICK,
                id: Appconstants.submit + " " + Appconstants.success,
                pageid: Appconstants.profilePageId
              }
              this.telemetryService.interact(telemetryEventData);
          }*/

            // this.pageLoad= false;
            // this.router.navigate(['app-home/investor/thingstodo'])
          }
          else {
            this.blnSuccessPopup=false;
            this.strErrorMessage = this.strVerifyResponse['message'];
            this.pageLoad= false;
            /*if(environment.telemetryFlg){
              let telemetryEventData = {
                type: INTERACTEVENTS.CLICK,
                id: Appconstants.submit + " " + Appconstants.error +" "+ this.strErrorMessage ,
                pageid: Appconstants.profilePageId
              }
              this.telemetryService.interact(telemetryEventData);
          }*/

          }
        },err=>{
          console.log(err);
          this.blnSuccessPopup=false;
          this.strErrorMessage = "Some Error Occured, Please try later.";
          this.pageLoad= false;
          /*if(environment.telemetryFlg){
            let telemetryEventData = {
              type: INTERACTEVENTS.CLICK,
              id: Appconstants.submit + " " + Appconstants.failure +" "+ err ,
              pageid: Appconstants.profilePageId
            }
            this.telemetryService.interact(telemetryEventData);
        }*/

            
        });
       
  }
  count: number = 0;
  countJS: number = 0;
  checkCountPerc(i) {
    this.count = this.primarySharePerc;

    if (this.JSdataToSubmitArray.length > 0) {
      this.countJS = 0;
      this.JSdataToSubmitArray.map(ele => {
        this.countJS += Number(ele['sharepercent']);
      })
    }
    if (i == -1) {
      if ((-(-this.primarySharePerc) > 100 || -(-this.primarySharePerc) < 0)) {
        this.StrPrimaryPercentError = 'enter valid percentage';
        this.primarySharePerc = this.profileData['share_percent'];
         return;
      }

      else if (this.countJS > 0 && -(-this.primarySharePerc) + this.countJS > 100) {
         this.StrPrimaryPercentError = "share percent including primary share can't exceed 100.";
       return;
      }
      else {
        this.StrPrimaryPercentError = '';
        return;
      }
    }

    if (this.count + this.countJS > 100) {
      this.StrPercentError[i] = "sum of share percent including primary share must be 100.";
      this.JSdataToSubmitArray[i]['sharepercent'] = 0;
      this.enableAttach(0,i);

      this.countJS = 0;
      return false;
    }
    else {
      this.StrPercentError[i] = '';
      return true;
    }
  }
  enableAttach(value, index) {
    console.log("enableAttach", value, index);
    this.indexAttach = index;
    if (-(-value) < 0) {
      this.JSValidationArray[index].sharepercent = false;
      this.JSdataToSubmitArray[index].residency = '';
      this.JSdataToSubmitArray[index].countrycode = '';
      this.JSdataToSubmitArray[index].document_details.documentName = '';
      this.JSdataToSubmitArray[index].document_details.documentContent = '';
      (<HTMLInputElement>document.getElementById('uploadDoc' + index)).value = "";


      this.JSValidationArray[index].country_code = undefined;
      this.JSValidationArray[index].residency = undefined;
      this.JSValidationArray[index].document = undefined 
     return;
    }
    if (-(-value) == 0 || value == null) {
      this.JSValidationArray[index].sharepercent = true;
      // this.JSValidationArray[index].document = true;

      this.JSdataToSubmitArray[index].residency = '';
      this.JSdataToSubmitArray[index].countrycode = '';
      this.JSdataToSubmitArray[index].document_details.documentName = '';
      this.JSdataToSubmitArray[index].document_details.documentContent = '';
      (<HTMLInputElement>document.getElementById('uploadDoc' + index)).value = "";

      this.JSValidationArray[index].country_code = undefined;
      this.JSValidationArray[index].residency = undefined;
      this.JSValidationArray[index].document = undefined;
      console.log("hello",this.JSValidationArray);
      return;
    }
    if (-(-value) > 0) {
      this.checkCountPerc(index);
      this.JSValidationArray[index].sharepercent = true;

      this.JSdataToSubmitArray[index].countrycode == null || this.JSdataToSubmitArray[index].countrycode == '' ? this.JSValidationArray[index].country_code = undefined : this.JSValidationArray[index].country_code = true;
      this.JSdataToSubmitArray[index].residency == null || this.JSdataToSubmitArray[index].countrycode == '' ? this.JSValidationArray[index].residency = undefined : this.JSValidationArray[index].residency = true;
      this.JSdataToSubmitArray[index].document_details.documentName == '' ? this.JSValidationArray[index].document = undefined : this.JSValidationArray[index].document = true;
     
    }
  }

  

  checkDisable(sharepercent, indx) {
    console.log(Number(sharepercent), indx);

    if (sharepercent == '') {
      this.JSflags[indx] = false;
      return true;
    }
    else {
      if (Number(sharepercent) > 100 || Number(sharepercent) < 0) {
        this.JSflags[indx] = false;
        return true;
      }
      else {
        return false;
      }
    }
  }
  primaryName:string
  getProfileData() {
    //debugger
    //debugger
    this.investorService.getProfileDataById().subscribe((data) => {
      console.log('profiledata', data);
      this.profileData = data['primary_demat_profile'][0];
      for(let cycle of data['cycle_details']){
        if(cycle['isactive']==1){
          this.windowStart=new Date(cycle['window_start']);
          this.windowStart.setHours(0,0,0,0);
          this.windowEndDate=new Date(cycle['window_end']);
          this.windowEnd.setTime(this.windowEndDate.getTime()+(24*60*60*1000));
          this.windowEnd.setHours(0,0,0,0);
          if(this.windowStart<=this.today && this.windowEnd>=this.today){
            this.windowFlag=true;
            sessionStorage.setItem("windowFlag","enable");
            console.log("inside sessionstorage setitem");
          }
          else{
            this.windowFlag=false;
          }
        }
      }
      // this.cycle_details=data['cycle_details'][0];
      // if (this.cycle_details['isactive'] == '0') {
      //   this.cycleFlag = true;
      // }
      // else{
      //   this.cycleFlag = false;
      // }
      
      this.shareholder_details = data['primary_demat_profile'][0]['shareHolderList'];
      this.other_demat_profile = data['other_demat_profile'];
      this.all_demat_account = data['all_demats'];
      this.primaryName = this.profileData['name_user'];
      this.panNumber=this.profileData['pan_user'];
      let pan=this.panNumber;
      if(environment.maskingFlag==true){
        this.panNumber = pan.substring(0,3) + 'X'.repeat(pan.length-6) + pan.substring(pan.length-3,pan.length);
      }
      let str = this.profileData['name_user'];
      let strWS = str.replace(' ','');
      if (str.length >= 6 && environment.maskingFlag==true) {
        this.primaryName = strWS.substring(0,3) + 'X'.repeat(strWS.length-6) + strWS.substring(strWS.length-3,strWS.length);
      }
     
      this.pageLoad = false;
      if (this.shareholder_details.length != 0) {
        if (this.profileData['share_percent'] == null || this.profileData['share_percent'] == '') {
          this.primarySharePerc = 100;
        }
        else {
          this.primarySharePerc = this.profileData['share_percent'];
        }
      }


      this.postModel.country_code = this.profileData['country_code'];
      this.checkNR();
      this.createJSArray();
      // if (this.profileData['isNR'] == 'R') {
      //   this.disableFlag = true;
      //   this.postModel.country_code = 'IN';
      // }
      // if(this.profileData['isNR'] == 'N' && (this.profileData['legal_code'] == 'FPC' || this.profileData['legal_code'] == 'FII')){
      //   this.postModel.country_code = this.profileData['country_code'];
      // }
      this.primaryDpFolioId = this.profileData['primarydp_id'] + this.profileData['primaryfolio_id'];
       this.selDemat=this.primaryDpFolioId;
    },
      err => {
        console.log(err);
        this.pageLoad = false;
        // this.blnFailure = true;
        this.strErrorMessage = "Some error occured. Please try again later."
        // this.blnShowBackdrop = false;
      })
  }

  getContry() {
    this.investorService.getContry().subscribe((data) => {
      this.contryData = data;
      console.log("contryData", this.contryData);
    },
      err => {
        console.log(err);
        // this.blnFailure = true;
        // this.strMessage = "Some error occured. Please try again."
        // this.blnShowBackdrop = false;
      })
  }

  clickEvent(index) {
    // this.status = !this.status;
    console.log("clickev", index);

    this.indexNum = index;
    
  }

  jsNames = [];
  createJSArray() {
    this.JSdataToSubmitArray = [];
    this.JSValidationArray = [];
    this.jsNames = [];
    this.JSflags = [];
    if (this.shareholder_details.length > 0) {
      this.shareholder_details.map((js, i) => {
        this.JSdataToSubmitArray.push({ shareHolderNumber: Number(js.shareholderNo), sharepercent: js.percent, countrycode: js.countrycode, residency: js.residency, legalstatus: js.legalstatus, document_details: { documentContent: '', documentName: '', documentType: 'selfdeclaration_'+i } })
        this.JSflags.push(false);
        this.JSValidationArray.push({ sharepercent: true, country_code: true, residency: true, document: true });

        this.jsNames[i] = js['name'];
        let str = js['name'];
        let strWS = str.replace(' ', '');
        if (str.length >= 6 && environment.maskingFlag==true) {
          this.jsNames[i] = strWS.substring(0, 3) + 'X'.repeat(strWS.length - 6) + strWS.substring(strWS.length - 3, strWS.length);
        }
        console.log("jsNames", this.jsNames[i], this.jsNames[i].length, strWS);


        // this.JSdataToSubmitArray[i].sharepercent!=null&& this.JSdataToSubmitArray[i].sharepercent!= 0 ?this.JSValidationArray[i].sharepercent=true:this.JSValidationArray[i].sharepercent=undefined;
        // this.JSdataToSubmitArray[i].countrycode!=null&& this.JSdataToSubmitArray[i].countrycode!= '' ?this.JSValidationArray[i].country_code=true:this.JSValidationArray[i].country_code=undefined;
        // this.JSdataToSubmitArray[i].residency!=null&& this.JSdataToSubmitArray[i].residency!= '' ?this.JSValidationArray[i].residency=true:this.JSValidationArray[i].residency=undefined;


        // this.JSdataToSubmitArray[i].legalstatus!=null&& this.JSdataToSubmitArray[i].legalstatus!= '' ?this.JSValidationArray[i].legalstatus=true:this.JSValidationArray[i].legalstatus=undefined;
        // this.JSdataToSubmitArray[i].sharepercent!=null&& this.JSdataToSubmitArray[i].sharepercent!= 0 ?this.JSValidationArray[i].sharepercent=true:this.JSValidationArray[i].sharepercent=undefined;

        if (this.JSdataToSubmitArray[i].sharepercent != null && this.JSdataToSubmitArray[i].sharepercent != 0) {
          this.JSValidationArray[i].document = undefined;
        }
      })
    }
    console.log("JS Validation", this.JSValidationArray, this.JSdataToSubmitArray);

  }


  changeResidentFlag(i) {
    this.JSdataToSubmitArray[i]['countrycode'] = 'IN',
      this.JSValidationArray[i].residency = true;
    this.JSValidationArray[i].country_code = true;
  }
  changeResidentFlagFalse(i) {
    this.JSdataToSubmitArray[i]['countrycode'] = '',
      this.JSValidationArray[i].residency = true;
    this.JSValidationArray[i].country_code = false;
  }

  flagdisableSave: boolean = true;
  flagArray = [];

  disableSave() {
    if (this.disableSubmit == true) {
      return true;
    }
    //     if(this.JSdataToSubmitArray.length==0){
    //       return false;
    //     }


    //     this.JSValidationArray.map((ele,i)=>{
    //       console.log(ele);
    //       // this.flagArray =[];
    // //  (this.JSdataToSubmitArray[i].countrycode == '' && this.JSdataToSubmitArray[i].residency == '' && this.JSdataToSubmitArray[i].document_details.documentName == '' )
    //       if(ele.sharepercent && (this.JSdataToSubmitArray[i].sharepercent==0|| this.JSdataToSubmitArray[i].sharepercent==null) && (ele.country_code == undefined &&  ele.residency == undefined &&ele.document == undefined)){
    //         this.flagArray[i] =true;
    //         // else{
    //         //   this.flagArray[i] =false;
    //         //   console.log("undefined1");
    //         // }
    //       }

    //       else if((ele.country_code === undefined ||  ele.residency === undefined ||ele.document === undefined) ){
    //         // this.flagdisableSave = true;
    //         this.flagArray[i] =false;
    //         console.log("other fields req");
    //         // return;

    //       }
    //       else if(ele.residency && ele.country_code && ele.sharepercent && ele.document){
    //         this.flagdisableSave = false;
    //         this.flagArray[i] =true;
    //         console.log("truea",this.flagdisableSave,this.flagArray);
    //       }
    //       else{
    //         this.flagdisableSave = true;
    //         this.flagArray[i] =false;
    //         console.log("falsea");
    //         // return;
    //       }
    //     })

    //     console.log("finalFlag", this.flagArray);
    //     if(this.flagArray.length){
    //       let sl = true;
    //       this.flagArray.map(ele=>{
    //         sl = sl&&ele;
    //       })
    //       if(sl){
    //         return false;
    //       }
    //       else{
    //         return true;
    //       }
    //     }
    //     else{
    //       return true
    //     }



  }

  checkJS() {
    if (this.profileData['isjointshareholding'] == 'Y') {
      return true;
    }
    else {
      this.primarySharePerc = 100;
      return false;
    }
  }


  checkJSForProfile(profile){
    if(profile['isjointshareholding']=='Y'){
      return true;
    }
    else {
      this.primarySharePerc = 100;
      return false;
    }
  }


  checkNR() {
    console.log('checkNR', this.selDemat);
    if (this.selDemat == '') {
      if (this.profileData.isNR == 'R') {
        this.isNR = 'R';
      }
      else {
        this.isNR = 'N';
      }
    }
    else {
      this.all_demat_account.map((ele, i) => {
        if (this.selDemat == ele.primarydp_id + ele.primaryfolio_id) {
          if (ele.isNR == 'R') {
            this.isNR = 'R';
          }
          else {
            this.isNR = 'N';
          }
        }
      })
    }
  }

  checkConsent(event) {
    if (event.target.checked) {
      console.log("incheck");
      this.disableSubmit = false;
    }
    else {
      console.log("not check");
      this.disableSubmit = true;

    }
  }

  scroll(id) {
    console.log("inclick", id);
    this.vps.scrollToAnchor(id)
  }

  reset(form: NgForm) {
    console.log("cancel");
    this.getProfileData();
  }
  closeModalPopup(){
    this.blnSuccessPopup=false;
    this.pageLoad= false;
    this.router.navigate(['app-home/investor/thingstodo'])
  }

  // downloadFile(docID: number, fileName: string, docName: string, status: string) {
  //   this.inputModelDwnloadFile = { intEmpDocId: docID };
  //   this.profileService.DownloadEdocketFile(this.inputModelDwnloadFile).subscribe(base64String => {
  //     this.base64ToFile(base64String, fileName.split(Appconstants.eDocketDlimiter)[1], docName, status);
  //   });
  // }

  // private base64ToFile(base64Data, extn, docName, status) {
  //   let byteArray: Uint8Array;
  //   let blob: Blob;
  //   let filename: string;
  //   let byteCharacters = atob(base64Data);
  //   let byteNumbers = new Array(byteCharacters.length);
  //   let link: HTMLAnchorElement;
  //   for (var i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }
  //   byteArray = new Uint8Array(byteNumbers);
  //   blob = new Blob([byteArray]);
  //   if (navigator.msSaveBlob) {
  //     filename = docName + status + '.' + extn;
  //     navigator.msSaveBlob(blob, filename);
  //   } else {
  //     link = document.createElement("a");
  //     link.href = URL.createObjectURL(blob);
  //     link.setAttribute('visibility', 'hidden');
  //     link.download = docName + status + '.' + extn;
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   }
  // }

  getProfile(){
    // console.log(this.selDemat)
    for(let profile of this.all_demat_account){
      if((profile['primarydp_id']+profile['primaryfolio_id'])==this.selDemat){
        this.shareholder_details=profile['shareHolderList'];
        this.profileData=profile;
      }
    }
    if (this.shareholder_details.length != 0) {
      if (this.profileData['share_percent'] == null || this.profileData['share_percent'] == '') {
        this.primarySharePerc = 100;
      }
      else {
        this.primarySharePerc = this.profileData['share_percent'];
      }
    }
    this.createJSArray();
  }

}
